// import firebase from 'firebase/app';
// import 'firebase/firestore';
import { app } from '../../firebase';

import ReduxSagaFirebase from 'redux-saga-firebase'

const sfb = new ReduxSagaFirebase(app);

export default sfb;